import { render, staticRenderFns } from "./CovidVaccinatedCrewList.vue?vue&type=template&id=755a018e&scoped=true&"
import script from "./CovidVaccinatedCrewList.vue?vue&type=script&lang=js&"
export * from "./CovidVaccinatedCrewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a018e",
  null
  
)

export default component.exports